/**
 * 네이버 지도 컴포넌트
 */

import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';

interface NaverMapProps {
  lat: number;
  lng: number;
  title: string;
}

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const NaverMap: React.FC<NaverMapProps> = ({ lat, lng, title }) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const clientId = 'o3xaj2fkq8';

  useEffect(() => {

    // 네이버 지도 스크립트 로드
    const script = document.createElement('script');
    script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${clientId}`;
    script.async = true;

    script.onload = () => {
      if (mapRef.current && window.naver && window.naver.maps) {
        // 지도 초기화
        const mapOptions = {
          center: new window.naver.maps.LatLng(lat, lng),
          zoom: 18,
          zoomControl: true,
          zoomControlOptions: {
            position: window.naver.maps.Position.TOP_RIGHT,
          },
        };

        const map = new window.naver.maps.Map(mapRef.current, mapOptions);

        // 마커 추가
        const marker = new window.naver.maps.Marker({
          position: new window.naver.maps.LatLng(lat, lng),
          map: map,
          title: title,
        });

        // 정보 창 추가
        const infoWindow = new window.naver.maps.InfoWindow({
          content: `
            <div style="padding: 15px; font-size: 14px; font-weight: 600; color: #333;">
              ${title}
            </div>
          `,
        });

        // 마커 클릭 시 정보 창 표시
        window.naver.maps.Event.addListener(marker, 'click', () => {
          if (infoWindow.getMap()) {
            infoWindow.close();
          } else {
            infoWindow.open(map, marker);
          }
        });

        // 기본적으로 정보 창 열어두기
        infoWindow.open(map, marker);
      }
    };

    document.head.appendChild(script);

    return () => {
      // 스크립트 정리
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [lat, lng, title, clientId]);

  return <MapContainer ref={mapRef} />;
};
